import { FormControl, TextField } from '@mui/material';
import React from 'react';
import { Controller, FieldValues, UseControllerProps } from 'react-hook-form';
import { EmailFieldConfiguration } from '../../../api/ConfigApi';
import FieldLabel from '../../fields/FieldLabel';

type FieldProps = Omit<EmailFieldConfiguration, 'name'>;
interface Props<T> extends FieldProps, UseControllerProps<T> {
	save?: (currValue: string, fieldName: string) => void;
}

const EmailField = <T extends FieldValues>(props: Props<T>) => {
	const { control, name, title, optional, disabled, save } = props;

	return (
		<Controller
			control={control}
			name={name}
			render={({ field, fieldState: { error } }) => (
				<FormControl error={!!error} sx={{ width: '100%' }}>
					<FieldLabel title={title} required={!optional} htmlFor={name} />
					<TextField
						{...field}
						fullWidth
						type='email'
						id={name}
						required={!optional}
						error={!!error}
						helperText={error?.message}
						disabled={disabled}
						onBlur={(e) => {
							field.onBlur();
							save && save(e.target.value, name);
						}}
					/>
				</FormControl>
			)}
		/>
	);
};

export default EmailField;
